import { render } from "./ShoppingTotalDetails.vue?vue&type=template&id=588b5dfc"
import script from "./ShoppingTotalDetails.vue?vue&type=script&lang=js"
export * from "./ShoppingTotalDetails.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__